import Alert from 'antd/lib/alert/Alert';
import InputNumber, { InputNumberProps } from 'antd/lib/input-number';
import Text from 'antd/lib/typography/Text';
import TypographyLink from 'antd/lib/typography/Link';
import * as React from 'react';
import { useHistory } from 'react-router-dom';
import { addShowStepConfigSettingsParam } from '@/helpers/routeHelpers';

export const AndroidStagedRolloutPercentageInput: React.FC<InputNumberProps> = (props) => (
    <InputNumber
        max={100}
        min={0}
        step={1}
        // this seems to be the maximum precision for Google Play staged rollouts.
        // For example, trying to set a rollout to 10.00000039% will lose precision and return 10.0000004% when fetching track data.
        precision={7}
        addonAfter={<Text style={{ fontSize: 16 }}>%</Text>}
        {...props}
    />
);

interface ReleaseOnlySettingsAlertProps {
    displayableVersion?: string;
    isWorkflowStep: boolean;
    onCloseModal: () => void;
}

export const ReleaseOnlySettingsAlert: React.FC<ReleaseOnlySettingsAlertProps> = ({
    displayableVersion,
    isWorkflowStep,
    onCloseModal,
}) => {
    const history = useHistory();

    const openStepSettings = () => {
        onCloseModal();
        history.push({ search: addShowStepConfigSettingsParam(history.location.search) });
    };

    return (
        <Alert
            showIcon
            type="info"
            message={
                <>
                    Changes saved here only apply to this release{displayableVersion ? ` (${displayableVersion})` : ''}.
                    To change the defaults for future releases, update your{' '}
                    {isWorkflowStep ?
                        <TypographyLink onClick={openStepSettings}>step settings</TypographyLink>
                    :   'app settings'}
                    .
                </>
            }
            style={{ marginBottom: 16 }}
        />
    );
};
